import React, { CSSProperties } from 'react'
import { connect } from 'react-redux'
import { Grid } from 'semantic-ui-react'
import { translate } from 'loankeeper-common/helpers'
import IconPreloader from 'loankeeper-common/components/IconPreloader'
//@ts-ignore
import withConstantPermissions from 'shared/containers/withConstantPermissions'
import { LKButton as LKBaseButton } from 'loankeeper-common/components'
import { translate as mainTranslate } from 'loankeeper-common/helpers'
import LKModal from '../../shared/LKModal'
import FormField from '../../shared/newFormElements'
import { GridContainer } from '../../shared/StyledComponents'

import {
  FORM_NAME,
  CHECK_DEBIT_ACCOUNT_FETCHER_NAME,
  CHECK_CREDIT_ACCOUNT_FETCHER_NAME,
  GET_DEBIT_ACCOUNT_VIEW_FETCHER_NAME,
  GET_CREDIT_ACCOUNT_VIEW_FETCHER_NAME,
} from './constants'

import ChangeAccountIDs from './ChangeAccountIDs'
import DebitAccountField from '../shared/DebitAccountField'
import DebitTitle from '../shared/DebitTitle'
import CreditAccountField from '../shared/CreditAccountField'
import CreditTitle from '../shared/CreditTitle'
import PrintOptions from '../shared/PrintOptions'
import AuthorizeCheckbox from '../shared/AuthorizeCheckbox'
import DebitAccountDetailsTrigger from '../shared/DebitAccountDetailsTrigger'
import CreditAccountDetailsTrigger from '../shared/CreditAccountDetailsTrigger'
import DebitBalance from '../shared/DebitBalance'
import CreditBalance from '../shared/CreditBalance'
import AddAndOpenAgainButton from '../shared/AddAndOpenAgainButton'
import DebitAccountAddButton from '../shared/DebitAccountAddButton'
import CreditAccountAddButton from '../shared/CreditAccountAddButton'
import CCYField from '../shared/CCYField'
//@ts-ignore
import { actions as LKModalActions } from 'shared/LKModal'
//@ts-ignore
import AuthorizeUnAuthorizeButton from '../shared/AuthorizeUnAuthorizeButton'
import Header from './Header'

import CommentsModal from '../CommentsModal'
import SearchAccountsButton from '../components/SearchAccountsButton'
import { MemorialAddModalProps } from './MemorialOrderAdd.types'
import { CommentsListItem } from '../CommentsModal/CommentsModa.types'

const translateLKMessage = (name: string): string => mainTranslate(`LKMESSAGE-${name}`)
const gridStyle = { marginRight: 7 }
const gridStyleTop = { marginTop: 8, marginRight: 7 }
const printOptStyle = { marginBottom: 7, marginLeft: 10, marginRight: 10 }

@withConstantPermissions(['ACC_ACCOUNT_OPEN as AddAccount'])
//@ts-ignore
@connect(undefined, {
  openErrorModal: (message: string) => LKModalActions.openError(message),
})
class MemorialAddModal extends React.Component<MemorialAddModalProps> {
  getModalHeading = () => {
    let heading = translate('frm_acc_entry_add-frm_acc_entry_add')

    if (this.props.params && this.props.params.ID && this.props.params.OID) {
      heading = `${heading}: ID - ${this.props.params.ID}, OID - ${this.props.params.OID}`
    }

    return heading
  }

  submitAndOpenAgain = () => {
    this.props.change('OpenAgain', true)

    // Strange ... OpenAgain was false/undefined when calling submit after change
    setTimeout(this.props.submit, 0)
  }

  submitAndClearOpenAgainFlag = () => {
    if (this.props.valid) {
      this.props.change('OpenAgain', false)

      // Strange ... OpenAgain was false/undefined when calling submit after change
      setTimeout(this.props.submit, 0)
    } else {
      this.props.openErrorModal(translateLKMessage('ERR_FILL_REQUIRED_FIELDS'))
    }
  }

  handleOpCodeChange = (selected: number) => {
    this.props.change('Comment', this.props.OpCode.find((code) => code.ID === selected).Destination)
  }

  handleCCYChange = () => {
    const { change } = this.props
    change('CreditAccNo', '')
    change('DebitChosenAccNo', '')
    change('CreditChosenAccNo', '')
    change('DebitAccNo', '')
    change('DebitAccID', '')
    change('CreditTitleUNI', '')
    change('DebitTitleUNI', '')
    change('CreditAccID', '')
    change('CreditAccBalance', 0)
    change('DebitAccBalance', 0)
  }
  debitAccountSearchButtonRef: any
  creditAccountSearchButtonRef: any

  render() {
    const {
      name,
      change,
      CCY,
      OpCode,
      submitting,
      form,
      params = {},
      onAuthorize,
      initialData,
      AddAccount,
    } = this.props

    return (
      //@ts-ignore
      <LKModal
        name={name}
        heading={this.getModalHeading()}
        size="medium"
        footer={
          //@ts-ignore
          <LKModal.Footer
            actions={
              params.authorizing ? (
                <AuthorizeUnAuthorizeButton
                  action={params.action}
                  data={initialData}
                  onAuthorize={onAuthorize}
                  name={name}
                  //@ts-ignore
                  details={{
                    OperTypeID: initialData.OperTypeID,
                    OID: initialData.OID,
                    HashSum_EntryID_: initialData.HashSum_EntryID_,
                    HashSum_OID_: initialData.HashSum_OID_,
                    EntryID: initialData.ID,
                  }}
                />
              ) : (
                <AuthorizeCheckbox FormName={FORM_NAME} />
              )
            }
            sideActions={
              params.authorizing ? (
                //@ts-ignore
                <LKModal.CancelButton
                  disabled={submitting}
                  loading={submitting}
                  text={translate('frm_acc_entry_add-cmd_close')}
                />
              ) : (
                <>
                  <AddAndOpenAgainButton
                    FormName={FORM_NAME}
                    submitting={submitting}
                    onClick={this.submitAndOpenAgain}
                  />
                  <LKBaseButton.Okay
                    //@ts-ignore
                    style={{ width: 85, marginRight: 0 } as CSSProperties}
                    disabled={submitting}
                    loading={submitting}
                    onClick={this.submitAndClearOpenAgainFlag}
                  />
                </>
              )
            }
          />
        }
        fullBody
      >
        <Header FormName={form} name={name} />
        <GridContainer style={gridStyleTop}>
          <Grid>
            <Grid.Row>
              <Grid.Column width={2} textAlign="right" verticalAlign="middle">
                {translate('frm_acc_entry_add-lbl_docno')}
              </Grid.Column>

              <Grid.Column width={2}>
                {/* @ts-ignore*/}
                <FormField disabled={params.authorizing} autoFocus name="DocNo" />
              </Grid.Column>

              <Grid.Column width={2} textAlign="right" verticalAlign="middle">
                {translate('frm_acc_entry_add-lbl_iso')}
              </Grid.Column>

              <Grid.Column width={2}>
                <CCYField
                  credit
                  debit
                  name="CCY"
                  disabled={params.authorizing}
                  FormName={FORM_NAME}
                  //@ts-ignore
                  ccy={CCY}
                  onChange={this.handleCCYChange}
                />
              </Grid.Column>

              <Grid.Column width={2} textAlign="right" verticalAlign="middle">
                {translate('frm_acc_entry_add-lbl_entrydate')}
              </Grid.Column>

              <Grid.Column width={2}>
                {/* @ts-ignore*/}
                <FormField disabled={params.authorizing} type="date" name="DocDate" />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </GridContainer>

        <hr />

        <GridContainer style={gridStyle}>
          <Grid>
            <Grid.Row>
              <Grid.Column width={2} textAlign="right" verticalAlign="middle">
                {translate('frm_acc_entry_add-lbl_debit')}
              </Grid.Column>

              <Grid.Column width={2} verticalAlign="middle">
                <DebitAccountField
                  FormName={FORM_NAME}
                  disabled={params.authorizing}
                  searchAccountsFetcherName={CHECK_DEBIT_ACCOUNT_FETCHER_NAME}
                  debitAccountSearchButtonRef={this.debitAccountSearchButtonRef}
                />
              </Grid.Column>

              <div className="u-flexCenter">
                <SearchAccountsButton
                  innerRef={(ref) => {
                    this.debitAccountSearchButtonRef = ref
                  }}
                  FormName={FORM_NAME}
                  disabled={params.authorizing}
                  modalName="SearchDebitAccounts"
                  accNo="DebitAccNo"
                  titleUNI="DebitTitleUNI"
                  accID="DebitAccID"
                  accHash="DebitAccHash"
                  accBalance="DebitAccBalance"
                  chosenAccNo="DebitChosenAccNo"
                  page="searchprefix"
                />

                <DebitAccountDetailsTrigger FormName={FORM_NAME} />
                <DebitAccountAddButton
                  disabled={params.authorizing || !AddAccount}
                  FormName={FORM_NAME}
                  fetcherName={GET_DEBIT_ACCOUNT_VIEW_FETCHER_NAME}
                />
              </div>

              <Grid.Column width={8} textAlign="center" verticalAlign="middle">
                <DebitTitle FormName={FORM_NAME} />
              </Grid.Column>

              <Grid.Column verticalAlign="middle" className="u-fluid">
                <DebitBalance FormName={FORM_NAME} />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </GridContainer>

        <hr />

        <GridContainer style={gridStyle}>
          <Grid>
            <Grid.Row>
              <Grid.Column width={2} textAlign="right" verticalAlign="middle">
                {translate('frm_acc_entry_add-lbl_credit')}
              </Grid.Column>

              <Grid.Column width={2} verticalAlign="middle">
                <CreditAccountField
                  FormName={FORM_NAME}
                  disabled={params.authorizing}
                  searchAccountsFetcherName={CHECK_CREDIT_ACCOUNT_FETCHER_NAME}
                  creditAccountSearchButtonRef={this.creditAccountSearchButtonRef}
                />
              </Grid.Column>

              <div className="u-flexCenter">
                <SearchAccountsButton
                  innerRef={(ref) => {
                    this.creditAccountSearchButtonRef = ref
                  }}
                  disabled={params.authorizing}
                  FormName={FORM_NAME}
                  modalName="SearchCreditAccounts"
                  accNo="CreditAccNo"
                  titleUNI="CreditTitleUNI"
                  accID="CreditAccID"
                  accHash="CreditAccHash"
                  accBalance="CreditAccBalance"
                  chosenAccNo="CreditChosenAccNo"
                  page="searchprefix"
                />

                <CreditAccountDetailsTrigger FormName={FORM_NAME} />
                <CreditAccountAddButton
                  disabled={params.authorizing || !AddAccount}
                  FormName={FORM_NAME}
                  fetcherName={GET_CREDIT_ACCOUNT_VIEW_FETCHER_NAME}
                />
              </div>

              <Grid.Column width={8} textAlign="center" verticalAlign="middle">
                <CreditTitle FormName={FORM_NAME} />
              </Grid.Column>

              <Grid.Column verticalAlign="middle" className="u-fluid">
                <CreditBalance FormName={FORM_NAME} />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </GridContainer>

        <hr />

        <GridContainer style={gridStyle}>
          <Grid>
            <Grid.Row>
              <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                {translate('frm_acc_entry_add-lbl_amount')}
              </Grid.Column>

              <Grid.Column width={2}>
                {/* @ts-ignore*/}
                <FormField disabled={params.authorizing} name="Amount" format type="float" autoComplete="off" />
              </Grid.Column>

              <Grid.Column width={3} />
              <ChangeAccountIDs disabled={params.authorizing} change={change} />
            </Grid.Row>
          </Grid>
        </GridContainer>

        <hr />

        <GridContainer style={gridStyle}>
          <Grid>
            <Grid.Row>
              <Grid.Column width={8} />

              <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                {translate('frm_acc_entry_add-lbl_opcode')}
              </Grid.Column>

              <Grid.Column width={6}>
                {/* @ts-ignore*/}
                <FormField
                  name="OpCodeID"
                  disabled={params.authorizing}
                  customOnChange={this.handleOpCodeChange}
                  type="select"
                  options={OpCode}
                  search
                />
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                {translate('frm_acc_entry_add-lbl_purpose')}
              </Grid.Column>

              <Grid.Column className="u-fluid">
                {/* @ts-ignore*/}
                <FormField disabled={params.authorizing} name="Comment" maxLength="300" />
              </Grid.Column>

              {/* @ts-ignore*/}
              <CommentsModal
                disabled={params.authorizing}
                OperTypeID={1}
                onRowChoose={(row: CommentsListItem) => change('Comment', row.Title)}
              />
            </Grid.Row>
          </Grid>
        </GridContainer>

        <hr />

        <div style={printOptStyle}>
          {/* @ts-ignore */}
          <PrintOptions FormName={FORM_NAME} change={change} ID={params.ID} hash={params.hash} OperTypeID={1} />
        </div>

        <IconPreloader collection="account" />
      </LKModal>
    )
  }
}

export default MemorialAddModal
